// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".w-button--loading{cursor:wait}.w-button__spinner{animation:showButtonSpinner .2s linear .2s backwards;color:inherit;height:.8em}@keyframes showButtonSpinner{0%{margin-right:0;max-width:0}to{max-width:1.3em}}.w-button__spinner-enter{transform:scaleX(0)}.w-button__spinner-enter-active{transition:transform .3s ease-out}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
